import React from 'react';
import { PageStatus } from '../../constants/PageStatus';
import ErrorPage from '../Error/ErrorPage';
import { RootStateOrAny, useSelector } from 'react-redux';
import RemoveMyEmail from './RemoveMyEmail';
import RemoveMyEmailConfirmation from './RemoveMyEmailConfirmation';

function RemoveMyEmailPage() {
  const pageStatus = useSelector(
    (state: RootStateOrAny) => state.pageInfo.pageStatus
  ) as PageStatus;

  if (pageStatus == PageStatus.INITIAL) return <RemoveMyEmail />;
  else if (pageStatus == PageStatus.SUCCESS)
    return <RemoveMyEmailConfirmation />;
  else return <ErrorPage />;
}

export default RemoveMyEmailPage;
